<template>
  <v-card class="mx-auto">
    <v-app-bar absolute color="primary" dark>
      <v-toolbar-title> Edit Fields</v-toolbar-title>
    </v-app-bar>
    <v-card-text>
      <br />
      <br />
      <br />
      <br />
      <v-row justify="center">
        <v-col cols="12" md="4" class="p-0">
          <div class="title">Required Fields</div></v-col
        >
        <v-col cols="12" md="4" class="p-0">
          <div class="title">Fields in File</div></v-col
        >
      </v-row>

      <v-row
        v-for="(header, i) in headers.filter(
          (e) => !['Success', 'Reason'].includes(e.headerName)
        )"
        :key="i"
        justify="center"
      >
        <v-col cols="12" md="4">
          <v-text-field
            readonly
            :value="header.field"
            outlined
            dense
            hide-details
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <v-select
            :items="fileHeaders"
            dense
            :success="checkSuccessStatus(matchColumn(header))"
            :value="getValue(header, i)"
            item-text="headerName"
            item-value="field"
            @change="(val) => updateColumn(val, i)"
            prepend-icon="mdi-arrow-right"
            return-object
            outlined
            hide-details
          ></v-select>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="save"> OK </v-btn>
      <v-btn color="primary" @click="close"> CANCEL </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "FieldSettings",
  data() {
    return {
      fileHeaders: [],
      headers: [],
    };
  },
  watch: {
    fileHeaders(val) {
      return val;
    },
  },
  methods: {
    reset() {
      this.fileHeaders = [];
      this.headers = [];
    },
    levenshteinDistance(str1 = "", str2 = "") {
      const track = Array(str2.length + 1)
        .fill(null)
        .map(() => Array(str1.length + 1).fill(null));
      for (let i = 0; i <= str1.length; i += 1) {
        track[0][i] = i;
      }
      for (let j = 0; j <= str2.length; j += 1) {
        track[j][0] = j;
      }
      for (let j = 1; j <= str2.length; j += 1) {
        for (let i = 1; i <= str1.length; i += 1) {
          const indicator = str1[i - 1] === str2[j - 1] ? 0 : 1;
          track[j][i] = Math.min(
            track[j][i - 1] + 1,
            track[j - 1][i] + 1,
            track[j - 1][i - 1] + indicator
          );
        }
      }
      return track[str2.length][str1.length];
    },
    getValue(header, i) {
      const max = this.matchColumn(header)?.key;
      this.headers[i] = {
        field: max || header.field,
        headerName: header.headerName,
      };
      return max;
    },
    matchColumn(header) {
      const res = [];
      this.fileHeaders.forEach((el) => {
        res.push({
          key: el.field,
          key2: header.field,
          result: this.levenshteinDistance(
            el.field.replace(/[^0-9a-z]/gi, "").toLowerCase(),
            header.field.replace(/[^0-9a-z]/gi, "").toLowerCase()
          ),
        });
      });
      let sorted = res.sort((a, b) => a.result - b.result);
      let isMax = sorted[0];
      return isMax;
    },
    updateColumn(val, i) {
      let current = this.headers[i];
      current.field = val.field;
      this.headers[i] = current;
    },
    setHeader(val) {
      this.headers = [...val];
    },
    checkSuccessStatus(data) {
      if ((data && data.result != null) || data != undefined) {
        return data.result == 0;
      }
      return false;
    },
    save() {
      try {
        this.$emit("updateHeader", this.headers);
        this.reset();
      } catch (error) {
        throw error;
      }
    },
    close() {
      let vm = this;
      vm.$emit("close", []);
      vm.reset();
    },
  },
};
</script>

<style lang="scss" scoped></style>
